import { useState } from "react";

const useToggle = () => {
    const [isOpen, setIsOpen] = useState(false);

    const toggle = () => setIsOpen((prevState) => !prevState);

    const open = () => setIsOpen(true);

    return { isOpen, toggle, open };
};

export default useToggle;
